import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dcV2gInverterValidator(
  control: AbstractControl
): ValidationErrors | null {
  const root = control.root?.value;
  const equipment =
    root?.equipment_information ??
    control.parent?.value ??
    root;
  const isDcV2g = equipment?.v2g_equipment?.v2g_type === 'DC V2G';
  const hasInverter = Array.isArray(control.value) && control.value.length > 0;

  return isDcV2g && !hasInverter
    ? { invalidDcV2gInverter: true }
    : null;
}
